import SemanticBody from './components/SemanticBody'
import SemanticTools from './components/SemanticTools'
import { _hub_scrolling } from './components/hub'
import { debug } from './constants'
import './css/main.scss'
import './css/speed-vis.scss'
import './socket'
import React, { Component } from 'react'
import 'regenerator-runtime/runtime.js'

let scrollTimeout = null
window.onscroll = () => {
  if (scrollTimeout) clearTimeout(scrollTimeout)
  _hub_scrolling.current = true
  // use timeout to clear this state
  scrollTimeout = setTimeout(() => {
    _hub_scrolling.current = false
  }, 200)
}

// setInterval(() => {
//   _hub_scrolling.current = false
// }, 1000)

document.addEventListener('contextmenu', e => {
  e.preventDefault()
  e.stopImmediatePropagation()
})

export default class App extends Component {
  componentDidMount() {
    if (!debug) {
      if (document.querySelector('.speed-vis'))
        document.querySelector('.speed-vis').style.display = 'none'
    }
  }

  render() {
    return (
      <>
        <div className="speed-vis">SPEED</div>
        <SemanticBody />
        <SemanticTools />
      </>
    )
  }
}
